import {FC} from 'react';

interface AwardProps {}

export const Award: FC<AwardProps> = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3970_13631)">
        <path
          d="M9.81529 13.5714C13.3657 13.5714 16.2439 10.6932 16.2439 7.1428C16.2439 3.5924 13.3657 0.714233 9.81529 0.714233C6.26489 0.714233 3.38672 3.5924 3.38672 7.1428C3.38672 10.6932 6.26489 13.5714 9.81529 13.5714Z"
          stroke="black"
          strokeWidth="1.42857"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.81417 9.99993C11.3921 9.99993 12.6713 8.72074 12.6713 7.14279C12.6713 5.56483 11.3921 4.28564 9.81417 4.28564C8.23622 4.28564 6.95703 5.56483 6.95703 7.14279C6.95703 8.72074 8.23622 9.99993 9.81417 9.99993Z"
          stroke="black"
          strokeWidth="1.42857"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.57086 13.4571L7.31372 18.7428C7.28884 18.8433 7.24285 18.9373 7.1788 19.0186C7.11476 19.0998 7.03413 19.1665 6.94229 19.2142C6.84536 19.2563 6.74082 19.278 6.63515 19.278C6.52948 19.278 6.42494 19.2563 6.328 19.2142L1.58515 17.1428C1.48566 17.0958 1.39812 17.0268 1.3291 16.9411C1.26008 16.8554 1.21137 16.7552 1.18663 16.648C1.16188 16.5407 1.16175 16.4293 1.18623 16.322C1.21072 16.2147 1.25919 16.1144 1.328 16.0285L4.99943 11.4285"
          stroke="black"
          strokeWidth="1.42857"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.4258 13.3857L12.7115 18.7428C12.7371 18.845 12.7849 18.9402 12.8516 19.0217C12.9183 19.1032 13.0021 19.169 13.0972 19.2142C13.1915 19.2568 13.2938 19.2789 13.3972 19.2789C13.5007 19.2789 13.6029 19.2568 13.6972 19.2142L18.4115 17.1428C18.5125 17.0963 18.6012 17.027 18.6707 16.9402C18.7401 16.8533 18.7883 16.7515 18.8115 16.6428C18.8386 16.5365 18.8397 16.4252 18.8149 16.3183C18.79 16.2114 18.7399 16.112 18.6686 16.0285L14.8401 11.1571"
          stroke="black"
          strokeWidth="1.42857"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3970_13631">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
